import { FunctionComponent, lazy, Suspense } from 'react';

// Lazy import the TinyMceEditor component
// @ts-ignore
const TinyMceEditor = lazy(() => import("@tinymce/tinymce-react").then(module => ({ default: module.Editor })));

export interface RichTextTextEditorProps
{
    /** The name of the field. */
    field: string;
    /** The label for the editor. */
    label?: string;
    /** Is this field required? */
    isRequired?: boolean;
    /** Is the editing enabled? */
    isEnabled?: boolean;
    /** The placeholder for the field value. */
    placeholder?: string;
    /** The number of rows in the editor. */
    rows?: number;
    /** The value of the field. */
    value?: string;
    /** Fired when the field value changes in the editor. */
    onValueChanged?: (field: string, value: string) => void;
    /** CSS class for the control. */
    className?: string;
}

/**
 * Component: a wrapper around the TinyMCE editor
 */
const RichTextTextEditor: FunctionComponent<RichTextTextEditorProps> = (props) =>
{
    const rows = props.rows ?? 6;
    const isEnabled = props.isEnabled ?? true;

    /** Render */
    return (
        <Suspense fallback={<div>Loading Editor...</div>}>
            <TinyMceEditor
                tinymceScriptSrc="https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.0.1/tinymce.min.js"
                value={props.value ?? ''}
                disabled={!isEnabled}
                init={{
                    height: rows * 60,
                    placeholder: props.placeholder,
                    menubar: true,
                    plugins: [
                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                    ],
                    toolbar: 'undo redo | blocks | ' +
                        'bold italic forecolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                }}
                // @ts-ignore
                onEditorChange={(content, editor) => { if (props.onValueChanged) props.onValueChanged(props.field, content) }}
            />
        </Suspense>
    );
}

export default RichTextTextEditor;